/**
 * Utility functions for Follow-up Sheet
 */

/**
 * Calculate age from date of birth
 */
export const calculateAge = (dob) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age.toString();
};

/**
 * Get initial date from visit details or return today's date
 */
export const getInitialDate = (visitDetails) => {
    if (visitDetails?.appointmentDate) {
        const dateStr = visitDetails.appointmentDate;
        if (typeof dateStr === 'string') {
            return dateStr.slice(0, 10);
        }
        return new Date(dateStr).toISOString().split('T')[0];
    }
    return new Date().toISOString().split('T')[0];
};

/**
 * Format date for filename (YYYY-MM-DD)
 */
export const formatDateForFilename = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Sanitize filename by removing special characters
 */
export const sanitizeFilename = (name) => {
    return name.replace(/[^a-zA-Z0-9]/g, '_').replace(/\s+/g, '_');
};

/**
 * Generate filename for print
 */
export const generatePrintFilename = (patientName) => {
    const downloadDate = formatDateForFilename(new Date());
    const sanitizedPatientName = sanitizeFilename(patientName);
    return `${sanitizedPatientName}_Investigation_Profile_${downloadDate}`;
};
